import { useContext } from 'react';

import { AdminExamLocationDetailContext } from './admin-exam-location-detail-provider';

function useAdminExamLocationDetail() {
  const context = useContext(AdminExamLocationDetailContext);

  if (!context) {
    throw new Error(
      'useAdminExamLocationDetail must be used within an AdminExamLocationDetailProvider',
    );
  }

  return context;
}

export { useAdminExamLocationDetail };
